import React from 'react';
import { useTEF } from 'src/tef/components/providers/TEFProvider';
import { cn } from 'src/tef/components/utils/cn';
import { forwardProps } from 'src/tef/components/utils/forwardProps';
import type { ForwardedHTMLProps } from 'src/tef/components/utils/types';

import { useCardContext } from './CardContext';

interface CardHeaderProps extends ForwardedHTMLProps {
  children: React.ReactNode;
  className?: string;
}

export const CardHeader = React.forwardRef<HTMLDivElement, CardHeaderProps>(
  ({ children, className, ...props }, ref) => {
    const tef = useTEF();
    const forwardedProps = forwardProps(props);
    const cardContext = useCardContext();

    const spacingValue = cardContext?.spacing || 'default';
    const spacingMap = {
      none: '',
      compact: '-mx-3 -mt-3 px-3',
      default: '-mx-5 -mt-5 px-5',
      spacious: '-mx-8 -mt-8 px-8',
    };

    return (
      <div
        ref={ref}
        className={cn(spacingMap[spacingValue], 'py-4 border-b', tef.colors.border, tef.colors.foreground, className)}
        {...forwardedProps}
        {...props}
      >
        {children}
      </div>
    );
  }
);

CardHeader.displayName = 'CardHeader';
